module.exports = __webpack_public_path__ + "static/img/group-6@2x.f87b6ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/group-6@2x.jpg
// module id = 5k/T
// module chunks = 1